module.exports = __webpack_public_path__ + "static/media/vulnerability-assessment.0c7878c1.png";